import React from "react";
import EditSvg from "./svg/edit.js";
import DeleteSvg from "./svg/delete.js";

export default function ProfileVehiculesPopup({
  vehicules,
  onEditVehicule,
  onDeleteVehicule,
  onAddVehicule,
}) {
  return (
    <div className="profile-div input-container profile-section-block" style={{ width: '100%' }}>
      <span className="profile-span">VÉHICULES</span>
      <div className="profile-div" style={{ display: 'flex', marginTop: '2rem' }}>
        <div className="profile-entity-list-grid">
          {vehicules.filter(v => !v.deleted && (v.type === 'TE' || v.type === 'AE')).map(v => (
            <React.Fragment key={v.idVehicule}>
              <div>
                {v.type === 'TE' && <span className="profile-span">{v.description} ({v.noPlaque})</span>}
                {v.type === 'AE' && <span className="profile-span">{v.description}</span>}
              </div>
              <div>
                <EditSvg className="clickable primary-color-on-hover" onClick={e => {
                  onEditVehicule(v);
                }} />
              </div>
              <div>
                <DeleteSvg className="clickable primary-color-on-hover" onClick={e => {
                  onDeleteVehicule(v);
                }} />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="profile-div">
        <div style={{ display: 'grid', padding: '8px' }}>
          <span className="label primary clickable" style={{ textTransform: 'initial' }} onClick={e => {
            onAddVehicule();
          }}>Cliquez ici pour ajouter un véhicule</span>
        </div>
      </div>
    </div>
  );
}
